import { render, staticRenderFns } from "./DocumentReadActivity.vue?vue&type=template&id=d27c702e"
import script from "./DocumentReadActivity.vue?vue&type=script&lang=ts"
export * from "./DocumentReadActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports